module.exports = __webpack_public_path__ + "img/1.5a02caa4.png";